const _ = require('lodash');

function InspirationService(Restangular, $rootScope, $window, localStorageWrapper) {
    this._api = Restangular.one('inspiration');
    this.$rootScope = $rootScope;
    this.$window = $window;
    this.localStorageWrapper = localStorageWrapper;
}

InspirationService.prototype.getNavigationItems = function () {
    this._leftPaneItems = this._leftPaneItems || this._api.one('navigation').getList();

    return this._leftPaneItems;
};

InspirationService.prototype.findNavigationItemsByName = function (navItems, parentName, childName) {
    let navItem = _.find(navItems, { UrlPart: parentName });

    if (childName !== undefined && navItem && _.some(navItem.Items)) {
        navItem = _.find(navItem.Items, { UrlPart: childName });
    }

    return navItem;
};

InspirationService.prototype.getCardsByPageID = function (pageId) {
    return this._api.one('page', pageId).get();
};

InspirationService.prototype.getCardsForUrl = function (url) {
    return this._api.one('cards').get({ url });
};

InspirationService.prototype.getDiscoverPathForCard = function (cardId) {
    return this._api.one('cards', cardId).one('DiscoverPath').get();
};

InspirationService.prototype.setContentCardId = function (cardId) {
    // Disabled due to https://github.com/eslint/eslint/issues/5692
    // Please re-enable if the issue is fixed.
    /* eslint-disable prefer-const */
    let stateChangeErrorOff;
    this._removeDataSessionStorage('dynamicContentCardId');// just in case


    const clickContentCardOff = this.$rootScope.$on('$stateChangeSuccess', () => {
        this.ContentCardId = cardId;
        stateChangeErrorOff();
        clickContentCardOff();

        const navigateAwayOff = this.$rootScope.$on('$stateChangeStart', () => {
            this.ContentCardId = null;
            navigateAwayOff();
        });
    });

    stateChangeErrorOff = this.$rootScope.$on('$stateChangeError', () => {
        this.ContentCardId = null;
        stateChangeErrorOff();
        clickContentCardOff();
    });
    /* eslint-enable prefer-const */
};

// Attributes that controls the center panel's behavior for SmallFormat when the item has no children items
InspirationService.prototype.setChildlessItem = function (childlessItem) {
    this._isChildLessItem = childlessItem;
};

InspirationService.prototype.isChildlessItem = function () {
    return this._isChildLessItem;
};

InspirationService.prototype.setDynamicContentCardIdSessionStorage = function (cardId) {
    this._setDataSessionStorage('dynamicContentCardId', cardId);
};

InspirationService.prototype._setNavigateAwayOff = function () {
    const navigateAwayOff = this.$rootScope.$on('$stateChangeSuccess', () => {
        this._removeDataSessionStorage('dynamicContentCardId');
        navigateAwayOff();
    });
};

InspirationService.prototype.getContentCardId = function () {
    this._setNavigateAwayOff();
    return this.ContentCardId
        ? this.ContentCardId
        : this._getDataSessionStorage('dynamicContentCardId');
};

// private session storage apis

/**
 * Create an item in DOM sessionStorage.
 * @param {String} name
 * @param {Object} data
 */
InspirationService.prototype._setDataSessionStorage = function (name, data) {
    this.localStorageWrapper.set(name, data);

    return data;
};

/**
 * Remove an item in DOM sessionStorage.
 * @param {String} name
 */
InspirationService.prototype._removeDataSessionStorage = function (name) {
    this.localStorageWrapper.remove(name);

    // allow chaining
    return this;
};

/**
 * Gets an item in DOM sessionStorage.
 * @param {String} name
 */
InspirationService.prototype._getDataSessionStorage = function (name) {
    return this.localStorageWrapper.get(name) || null;
};

module.exports = InspirationService;



// WEBPACK FOOTER //
// ./src/inspiration/inspiration.service.js